import { useCallback } from 'react';

import { logger } from '@zep/core-logger';

interface UseGoToLmsHandlerParams {
  quizId: string;
}

/**
 * useGoToLmsHandler - 학습 리포트 페이지 이동 핸들러
 *
 * @description
 * 학습 리포트 페이지를 새 탭으로 엽니다.
 */
export const useGoToLmsHandler = ({ quizId }: UseGoToLmsHandlerParams) => {
  return useCallback(() => {
    logger.track('enter_learningreport', { location: 'mydetail' });
    window.open(`/lms/${quizId}/learning-report`, '_blank');
  }, [quizId]);
};
